module.exports = __webpack_public_path__ + "img/copy-w.99843578.svg";